// package imports
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// CSS imports
import './EmailTemplateCard.css';

// Component imports
import DeleteButton from '../buttons/deleteButton/DeleteButton';
import Spinner from '../spinner/Spinner';
import PrimaryButton from '../buttons/primaryButton/PrimaryButton';

// Icon imports
import { FaRegCopy } from 'react-icons/fa6';

// Type imports
import { EmailTemplate } from '../../types/emailTemplates/EmailTemplate';
import TransparentButton from '../buttons/transparentButton/TransparentButton';

type Props = {
  className?: string;
  template: EmailTemplate;
  index: number;
  deleteTemplate: (id: string, x: number) => Promise<void>;
  duplicateTemplate: (id: string) => Promise<void>;
};

const EmailTemplateCard: React.FC<Props> = ({
  className,
  template,
  index,
  deleteTemplate,
  duplicateTemplate,
}: Props) => {
  const [isLoading, setIsLoading] = useState(false);

  const triggerDeleteTemplate = async () => {
    setIsLoading(true);
    await deleteTemplate(template.id, index);
    setIsLoading(false);
  };

  const triggerDuplicateTemplate = async () => {
    setIsLoading(true);
    await duplicateTemplate(template.id);
    setIsLoading(false);
  };

  return (
    <div className={`EmailTemplateCard ${className ? className : ''}`}>
      <div className='side-container'>
        <span>{template.name}</span>
      </div>
      <div className='side-container'>
        <Link to={'/email-template/' + template.id} className='edit-link'>
          <PrimaryButton label='Edit' className='action-button' />
        </Link>
        <TransparentButton
          ReactIcon={FaRegCopy}
          className='icon-button'
          onClick={triggerDuplicateTemplate}
        />
        <DeleteButton onClick={triggerDeleteTemplate} />
      </div>
      {isLoading ? (
        <div className='loader-overlay'>
          <Spinner isLoading={true} />
        </div>
      ) : null}
    </div>
  );
};

export default EmailTemplateCard;
